import {
  FETCH_SUBSCRIBER
} from '@actions/types'

export const getSubscriber = (id) => ({
  type: FETCH_SUBSCRIBER,
  payload: {
    request: {
      method: 'get',
      url: `/subscribers/v1/${id}`
    }
  }
})
